import { FC, useState } from 'react';
import styled from 'styled-components';
import { Badge, Button, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  VsTransferEvent,
  useGetHeroConversationById,
} from '@vs-online-only-app/state';
import { IconTransfersExtraLarge, UserAvatar } from '@vs-online-only-app/ui';
import { RootTransferCard } from './OutgoingTransferCard';

const CloseCircle = styled.div`
  display: grid;
  place-content: center;
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.error.main};
  border-radius: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.common.white};
`;

type Props = {
  event: VsTransferEvent;
  onClose: () => void;
  slideIn?: boolean;
};

export const ExpiredTransferCard: FC<Props> = ({ event, onClose, slideIn }) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const { data: conversation } = useGetHeroConversationById(event.conversation);

  if (!conversation || !isVisible) {
    return null;
  }

  return (
    <RootTransferCard $slideIn={slideIn} elevation={1}>
      <Badge
        overlap="circular"
        badgeContent={
          <CloseCircle>
            <Close fontSize="small" />
          </CloseCircle>
        }
        sx={{ height: 'fit-content' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <UserAvatar icon={<IconTransfersExtraLarge />} large />
      </Badge>
      <Stack gap={2}>
        <Stack>
          <Typography variant="body2" fontWeight="bold">
            Transfer unsuccessful.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Your request was not accepted in time. Continue your chat with{' '}
            {conversation.conversationStarter.firstName} the best you can.
          </Typography>
        </Stack>
        <Button
          variant="outlined"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
            setIsVisible(false);
          }}
        >
          Close
        </Button>
      </Stack>
    </RootTransferCard>
  );
};
